import React from "react";
import styled from "styled-components";
import DashboardImage from "../../assets/img/dashboard2_426x607.png";
import DemoImage from "../../assets/img/demoimage.png";



const DemoImageSection = () => {
  const demoImages = [
    {
      title: "Dashboard Overview",
      description: "All your financial activities in one central place.",
      image: "https://via.placeholder.com/500x300?text=Dashboard",
    },

  
   
  ];

  return (
    <SectionWrapper>
      <SectionTitle>See ChamaFlow in Action</SectionTitle>
      <SubText>
        Explore how ChamaFlow simplifies group financial management through
        intuitive and powerful interfaces.
      </SubText>
      <ImageGrid>
        {demoImages.map((item, index) => (
          <ImageCard key={index}>
            <img src={DemoImage} alt={item.title} />
            <h4>{item.title}</h4>
            <p>{item.description}</p>
          </ImageCard>
        ))}
      </ImageGrid>
    </SectionWrapper>
  );
};

export default DemoImageSection;

const SectionWrapper = styled.section`
  padding: 60px 20px;
  max-width: 1200px;
  margin: auto;
  text-align: center;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 10px;
`;

const SubText = styled.p`
  font-size: 1rem;
  color: #555;
  margin-bottom: 40px;
`;

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
`;

const ImageCard = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  overflow: hidden;
  text-align: left;

  img {
    width: 100%;
    height: auto;
    display: block;
  }

  h4 {
    margin: 15px;
    font-size: 1.1rem;
    color: #333;
  }

  p {
    margin: 0 15px 15px;
    color: #666;
    font-size: 0.95rem;
  }
`;
